<div class="rendition-delete-container">
  <div class="icon-container">
    <qr-icon [name]="ICON_WARNING" [color]="ICON_COLOR_WHITE"></qr-icon>
  </div>
  <p>
    ¿Está seguro que desea
    <b> borrar todos los movimientos</b>?
  </p>
</div>
